import { useEffect } from "react";

import { Player } from "@/features/request/feedback-tool/feedbackTool/audio/components";
import { useFeedbackTool } from "@/features/request/feedback-tool/feedbackTool/hooks/useFeedbackTool.tsx";
import { useGetStories } from "@/features/request/feedback-tool/feedbackTool/hooks/useGetStories.tsx";
import { coordinateConvert } from "@/features/request/feedback-tool/feedbackTool/utils/coodinateConvert.ts";

import { checkTimestamp } from "../utils/checkTimestamp";

export default function FeedbackAudio({
  media,
}: {
  media: string | undefined;
}) {
  const { img, setFeedBack } = useFeedbackTool();
  const { data } = useGetStories({
    enable: false,
    parentId: img.id,
  });

  useEffect(() => {
    if (data) {
      setFeedBack(() =>
        data.length > 0
          ? data?.map((feedback, index) => ({
              attachments: feedback?.attachments
                ? feedback?.attachments.map((att) => ({
                    attachmentId: Number(att.attachmentId),
                    name: att.name,
                    storyId: Number(att.storyId),
                    url: att.url,
                  }))
                : [],
              commentBatchId: feedback.commentBatchId,
              description: feedback.comment ?? "",
              format: "AUDIO",
              id: index + 1,
              imgId: img.id,
              isResolved: feedback.isResolved ?? false,
              parentId: feedback.parentId,
              storyId: feedback.id,
              timestamp: checkTimestamp(
                Number(coordinateConvert(feedback.coordinates, "timestamp")),
              ),
              updatedAt: feedback.updatedAt,
              user: {
                id: feedback.user?.id,
                name: feedback.user?.name,
              },
              x: 0,
              y: 0,
            }))
          : null,
      );
    }
  }, [data]);

  return (
    <div className="relative flex justify-center items-center w-full">
      <Player media={media} />
    </div>
  );
}
